import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import FirmPage from './pages/FirmPage';
import AddFirmPage from './pages/AddFirmPage';
import ContactPage from './pages/ContactPage';
import VisionPage from './pages/VisionPage';
import AdminPage from './pages/AdminPage';

function App() {
  const [selectedCity, setSelectedCity] = useState('');

  const handleCityChange = (city) => {
    setSelectedCity(city);
  };

  return (
    <Router>
      <div className="App">
        <Header selectedCity={selectedCity} onCityChange={handleCityChange} />
        
        <main style={{ minHeight: 'calc(100vh - 200px)' }}>
          <Routes>
            <Route 
              path="/" 
              element={<HomePage selectedCity={selectedCity} />} 
            />
            <Route 
              path="/kategori/:categoryId" 
              element={<CategoryPage selectedCity={selectedCity} />} 
            />
            <Route 
              path="/firma/:firmId" 
              element={<FirmPage />} 
            />
            <Route 
              path="/firma-ekle" 
              element={<AddFirmPage />} 
            />
            <Route 
              path="/iletisim" 
              element={<ContactPage />} 
            />
            <Route 
              path="/vizyonumuz" 
              element={<VisionPage />} 
            />
            <Route 
              path="/admin" 
              element={<AdminPage />} 
            />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;